import { useAppSelector } from '../../buildStore';
import { getIsVoiceInputActive, getIsVoiceInputAwaitingPermission, getIsVoiceInputPermissionError, getIsVoiceInputTranscribeError } from '../selectors/voiceInputSelectors';
export const useVoiceInputStatus = () => {
  const isActive = useAppSelector(getIsVoiceInputActive);
  const isAwaitingPermission = useAppSelector(getIsVoiceInputAwaitingPermission);
  const isPermissionError = useAppSelector(getIsVoiceInputPermissionError);
  const isTranscribeError = useAppSelector(getIsVoiceInputTranscribeError);
  return {
    isActive,
    isAwaitingPermission,
    isPermissionError,
    isTranscribeError,
    isError: isPermissionError || isTranscribeError
  };
};